import React from "react";
import Header from "../../components/header";
import WalletComponent from "../../components/wallet";
import NavBar from "../../components/navBar";
import * as GS from "../../utils/globalStyles/background";

const Wallet: React.FC = () => {
  return (
    <GS.BackgroundApp>
      <Header />
      {/* <WalletComponent /> */}
      <GS.BodyContainer>
        <WalletComponent />
      </GS.BodyContainer>
      <GS.NavContainer>
        <NavBar />
      </GS.NavContainer>
      {/* <NavBar /> */}
    </GS.BackgroundApp>
  );
};

export default Wallet;
